import { BaseViewStore} from 'core/stores';
import { action, observable } from "mobx";

class FacilityOrderTemplateDoNotSupplyModalStore extends BaseViewStore {
    @observable accessor disabled = false;
    constructor(rootStore, componentProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.title = this.modalParams.data.title;
        this.description = this.modalParams.data.description;
        this.showTemplateChangeWarning = this.modalParams.data.showTemplateChangeWarning;
    }

    @action.bound
    async markDoNotSupply() {
        this.disabled = true;
        try {
            await this.modalParams.data.markDoNotSupply();
            if(this.showTemplateChangeWarning)
                this.showTemplateChangeWarning();
            this.modalParams.close();
        }
        catch (err) {
            this.disabled = false;
            return this.onUpdateError(err);
        }
        this.disabled = false;
    }
}

export default FacilityOrderTemplateDoNotSupplyModalStore;
